/**
 * Kadence Show More sets `inert` on collapsed content, which blocks clicks
 * on still-visible links. Keep the preview interactive while collapsed.
 */
(function () {
  var CONTENT_SELECTOR = '.kb-show-more-content';

  function restoreTabIndex(root) {
    root.querySelectorAll('[data-original-tabindex], [data-had-no-tabindex]').forEach(function (el) {
      var original = el.getAttribute('data-original-tabindex');
      if (original !== null) {
        el.setAttribute('tabindex', original);
        el.removeAttribute('data-original-tabindex');
      } else if (el.getAttribute('data-had-no-tabindex') === 'true') {
        el.removeAttribute('tabindex');
        el.removeAttribute('data-had-no-tabindex');
      }
    });

    // Links Kadence may have forced to tabindex=-1 without data attrs
    root.querySelectorAll('a[href][tabindex="-1"]').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  }

  function unlockContent(el) {
    if (!el || !el.classList.contains('kb-show-more-content')) return;
    if (el.hasAttribute('inert')) {
      el.removeAttribute('inert');
    }
    restoreTabIndex(el);
  }

  function unlockAll() {
    document.querySelectorAll(CONTENT_SELECTOR).forEach(unlockContent);
  }

  function observe() {
    if (!window.MutationObserver) {
      unlockAll();
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'inert') {
          unlockContent(mutation.target);
        }
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(CONTENT_SELECTOR)) {
              unlockContent(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll(CONTENT_SELECTOR).forEach(unlockContent);
            }
          });
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['inert'],
      childList: true,
      subtree: true
    });
  }

  function init() {
    unlockAll();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Kadence re-applies inert after Show Less; catch late updates
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.kb-show-more-buttons')) {
      window.setTimeout(unlockAll, 0);
      window.setTimeout(unlockAll, 100);
    }
  });
})();
